/**
 * The reference page on PSU efficiency and energy cost. One constant shared by
 * the build that renders the page and the app that links to it, so the link
 * cannot point somewhere the page is not.
 */
export const REFERENCE_PATH = '/pc-energy-cost/'
